import QueryDatabase from "./QueryDatabase";

export const getShoppingListData = async (serverProps, userID, shoppingList, setShoppingList, setServerAccess, startIndex = 0, amount = 12) => {
    setServerAccess(0);
    await QueryDatabase({
        user: userID,
        table: "shopping_list",
        method: 2,
        filter: "",
        data: "",
        serverName: serverProps.DatabaseServer,
        serverPort: serverProps.DatabasePort
    }).then((data) => {
        /*data= [{
         * Item_ID: int
        * Item_Name: string
        * Item_Quantity: int
        * Item_Recipe_Plan: (Plan_ID) can be null
        * Plan_Date: date, can be null
        * Recipe_Name: string, can be null
        * Item_Recipe_Plan_Ingredient: (Recipe_Ingredient_ID) can be null
        *  },...]*/
        setShoppingList([...shoppingList, ...data.map((datum) => {
            return {
                ...datum,
                Plan_Date: datum.Plan_Date ? new Date(datum.Plan_Date) : null
            }
        })])
        setServerAccess(1);
    })
}

export const addShoppingListItem = async (serverProps, userID, shoppingList, setShoppingList, itemData) => {
    await QueryDatabase({
        user: userID,
        table: "shopping_list",
        method: 0,
        filter: "",
        data: itemData,
        serverName: serverProps.DatabaseServer,
        serverPort: serverProps.DatabasePort
    }).then((data) => {
        if (data.insertId >= 0) {
            const newShoppingArray = [...shoppingList, {
                ...itemData,
                Item_ID:data.insertId
            }]
            setShoppingList(newShoppingArray)
        }
    })
}

export const editShoppingListItem = async (serverProps, userID, shoppingList, setShoppingList, itemData) => {
    await QueryDatabase({
        user: userID,
        table: "shopping_list",
        method: 5,
        filter: "",
        data: itemData,
        serverName: serverProps.DatabaseServer,
        serverPort: serverProps.DatabasePort
    }).then((data) => {
        if (data.affectedRows >= 0) {
            const newShoppingArray = shoppingList.map((listElement) => {
                if (listElement.Item_ID === itemData.Item_ID)
                    return itemData
                else return listElement
            })
            setShoppingList(newShoppingArray)
        }
    })
}

export const deleteShoppingListItem = async (serverProps, userID, shoppingList, setShoppingList, plans, setPlans, itemData) => {
    await QueryDatabase({
        user: userID,
        table: "shopping_list",
        method: 1,
        filter: "",
        data: itemData.Item_ID,
        serverName: serverProps.DatabaseServer,
        serverPort: serverProps.DatabasePort
    }).then((data) => {
        if (data.affectedRows === 1) {
            const newShoppingArray = shoppingList.filter((element) => element.Item_ID !== itemData.Item_ID)
            setShoppingList(newShoppingArray);
            const newPlans = plans.map((plan) => {
                if (plan.Plan_ID === itemData.Item_Recipe_Plan) {//find the affected plan
                    return {
                        ...plan,
                        Recipe_Ingredients: plan.Recipe_Ingredients.map((recipeIngredient) => {
                            if (recipeIngredient.Item_ID === itemData.Item_ID)//find the affected recipe ingredient
                                return {
                                    ...recipeIngredient,
                                    Item_ID: null//set Item_ID to null
                                };
                            else return recipeIngredient;
                        })
                    }
                }
                else
                    return plan;
            })
            setPlans(newPlans)
        }
    })
}

export const buyShoppingListItem = async (serverProps, userID, shoppingList, setShoppingList, setIngredients, ingredients, plans, setPlans, itemData) => {
    await QueryDatabase({
        user: userID,
        table: "shopping_list",
        method: 5,
        filter: "ingredients",
        data: {
            ...itemData,
            Plan_Date: itemData.Plan_Date?.toLocaleDateString().split("/").reverse().join("-")
        },
        serverName: serverProps.DatabaseServer,
        serverPort: serverProps.DatabasePort
    }).then((data) => {
        if (data[0].insertId) {
            setIngredients([...ingredients, {
                Ingredient_Name: itemData.Item_Name,
                Ingredient_Quantity:itemData.Item_Quantity,
                Ingredient_ID: data[0].insertId,
                Ingredient_Date: new Date("null"),
                Ingredient_Frozen: new Date("null"),
                Plan_Date: itemData.Plan_Date,
                Recipe_Name: itemData.Recipe_Name,
                Plan_ID: itemData.Item_Recipe_Plan,
                Recipe_Ingredient_ID:itemData.Item_Recipe_Plan_Ingredient
            }].sort((first, second) => (isNaN(first.Ingredient_Date) ? 0 : first.Ingredient_Date) - (isNaN(second.Ingredient_Date) ? 0 : second.Ingredient_Date) || first.Ingredient_ID - second.Ingredient_ID))//sort by date (NaN first), then ingredient id
        }
        if (data[1].affectedRows === 1) {//the deletion query succeeded
            const newShoppingArray = shoppingList.filter((element) => element.Item_ID !== itemData.Item_ID)
            setShoppingList(newShoppingArray)
        }

        const newPlans = plans.map((plan) => {
            if (plan.Plan_ID === itemData.Item_Recipe_Plan) {//find the affected plan
                return {
                    ...plan,
                    Recipe_Ingredients: plan.Recipe_Ingredients.map((recipeIngredient) => {
                        if (recipeIngredient.Item_ID === itemData.Item_ID)//find the affected recipe ingredient
                            return {
                                ...recipeIngredient,
                                Item_ID: data[1].affectedRows === 1 ? null : itemData.Item_ID,//set Item_ID to null if affected rows = 1 (so if the delete worked)
                                Ingredient_ID: (data[0].insertId || data[0].insertId === 0) ? data[0].insertId : null//set Ingredient_ID to insertID if insert id exists (including if it's 0)
                            };
                        else return recipeIngredient;
                    })
                }
            }
            else
                return plan;
        })
        setPlans(newPlans)
    })
}